export default __webpack_public_path__ + "static/media/header.23393922.png";